export default "__VITE_ASSET__snX4999g__"